import * as Sentry from '@sentry/react';
import { getEnv } from './utils';

/* *************** */
/*   Token Names   */
/* *************** */

/** The DEFAULT_TOKEN should enable service cost searches with the NCCT api. The prefix set on the member_id is AAP. */
export const DEFAULT_TOKEN = 'defaultToken';

/* ************** */
/*  Environments  */
/* ************** */
export const testing = {
  [DEFAULT_TOKEN]: '6589e8c1-bca6-4dc9-ab8e-ce9ace133dbb',
};

const staging = {
  [DEFAULT_TOKEN]: 'fae808cd-bc04-474e-9d6c-801f3fa49a8b',
};

const production = {
  [DEFAULT_TOKEN]: '4dd7c4bb-59c8-40a5-b3c2-29da1fe91df9',
};

/* ************ */
/*   Token Map  */
/* ************ */
const demoTokens = {
  testing,
  staging,
  production,
};

/**
 *
 * @param {string} tokenName
 * @example setDemoToken(DEFAULT_TOKEN)
 * Function that sets an integration token based on the tokenName parameter passed into localStorage.
 * The tokenName parameter must be one of the constants in demoTokens.js.
 * If there is no matching token found, we will continue to use the current integration token.
 */
export const setDemoToken = (tokenName) => {
  let env = getEnv();
  if (env === 'local') env = 'testing';
  const token = demoTokens?.[env]?.[tokenName];
  if (token) localStorage.setItem('integrationToken', token);
  else
    Sentry.captureMessage(
      `Unable to set Demo integration token from name: ${tokenName}`,
      (scope) => {
        scope.setLevel('warning');
      }
    );
};
